import { ErrorCodes } from 'mini-sds-gateway/lib/utils/errorCodes';
import { format } from 'owa-strings';
import { ITEM_ID_URL, ITEM_URL } from 'mini-sds-gateway/lib/utils/constants';
import { makeSDSNetworkCall } from 'mini-sds-gateway/lib/services/makeSDSNetworkCall';
import { setNotificationEnabled } from './setNotificationEnabled';
import { trace } from 'owa-trace';
import {
    BXCustomPropertiesDataKey,
    BXUserCustomPropertiesCollection,
    NotificationEnabledKey,
    NotificationSettingItemClass,
} from '../utils/constants';

const DEFAULT_NOTIFICATION_ENABLED_STATE = true;

// TODO: ashsingh, use SDS package functions instead of calling API directly
export async function isNotificationEnabled() {
    try {
        const response = await makeSDSNetworkCall(
            format(ITEM_URL, BXUserCustomPropertiesCollection),
            'GET'
        );
        if (response?.error?.code === ErrorCodes.CollectionIdNotFound) {
            await setNotificationEnabled(DEFAULT_NOTIFICATION_ENABLED_STATE);
            return DEFAULT_NOTIFICATION_ENABLED_STATE;
        }

        const items = response.value;
        let notificationItem = null;
        if (items.length) {
            notificationItem = items.find(
                ({ ItemClass }) => ItemClass === NotificationSettingItemClass
            );
        }

        if (!notificationItem) {
            await setNotificationEnabled(DEFAULT_NOTIFICATION_ENABLED_STATE);
            return DEFAULT_NOTIFICATION_ENABLED_STATE;
        }
        const { Id: itemId } = notificationItem;

        const item = await makeSDSNetworkCall(
            format(ITEM_ID_URL, BXUserCustomPropertiesCollection, itemId),
            'GET'
        );

        if (
            BXCustomPropertiesDataKey in item &&
            NotificationEnabledKey in item[BXCustomPropertiesDataKey]
        ) {
            return item[BXCustomPropertiesDataKey][NotificationEnabledKey];
        } else {
            await setNotificationEnabled(DEFAULT_NOTIFICATION_ENABLED_STATE);
            return DEFAULT_NOTIFICATION_ENABLED_STATE;
        }
    } catch (e) {
        trace.warn(e);
    }
}
